import { render } from "./QywxOrderListSaas.vue?vue&type=template&id=1bcd0d55"
import script from "./QywxOrderListSaas.vue?vue&type=script&lang=js"
export * from "./QywxOrderListSaas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/plat/qywxOrder/QywxOrderListSaas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bcd0d55"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bcd0d55', __exports__)) {
    api.reload('1bcd0d55', __exports__)
  }
  
  module.hot.accept("./QywxOrderListSaas.vue?vue&type=template&id=1bcd0d55", () => {
    api.rerender('1bcd0d55', render)
  })

}


export default __exports__